var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCzechrepublic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.154583 15.8982L12.0023 8L0.154583 0.101807C0.0634082 0.179029 0.00195312 0.290926 0.00195312 0.421044V15.5789C0.00195312 15.7091 0.0634082 15.821 0.154583 15.8982Z",
    fill: "#11457E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.154297 15.8982C0.226018 15.959 0.314849 16 0.415446 16H23.5886C23.8171 16 24.0024 15.8114 24.0024 15.5789V8H12.002L0.154297 15.8982Z",
    fill: "#D7141A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.154297 0.101786C0.226018 0.0410198 0.314849 0 0.415446 0H23.5886C23.8171 0 24.0024 0.188547 24.0024 0.421071V7.99998H12.002L0.154297 0.101786Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzechrepublic);
export default __webpack_public_path__ + "static/media/Czechrepublic.760ab71ee5b59d22ba65b78d3d34b292.svg";
export { ForwardRef as ReactComponent };